<template>
  <main-template>
    <!-- Título principal -->
    <v-row class="ma-4 mb-0">
      <v-col cols="12">
        <span class="text-h6 font-weight-bold">Dados para o Censo Escolar</span>
      </v-col>
    </v-row>

    <!-- Abas para navegação -->
    <v-row class="ma-4 mt-0">
      <v-col cols="12">
        <v-card outlined>
          <v-tabs v-model="tab" background-color="success" dark centered icons-and-text>
            <v-tab href="#tab-1" :disabled="tab !== 'tab-1'">
              Escola
              <v-icon>mdi-town-hall</v-icon>
            </v-tab>

            <v-tab href="#tab-2" :disabled="tab !== 'tab-2'">
              Estrutura
              <v-icon>mdi-bus-school</v-icon>
            </v-tab>

            <v-tab href="#tab-3" :disabled="tab !== 'tab-3'">
              Turmas
              <v-icon>mdi-account-group</v-icon>
            </v-tab>

            <v-tab href="#tab-4" :disabled="tab !== 'tab-4'">
              Pessoas Físicas
              <v-icon>mdi-card-account-details</v-icon>
            </v-tab>

            <v-tab href="#tab-5" :disabled="tab !== 'tab-5'">
              Gestão
              <v-icon>mdi-account-tie-outline</v-icon>
            </v-tab>

            <v-tab href="#tab-6" :disabled="tab !== 'tab-6'">
              Vínculos
              <v-icon>mdi-human-male-board</v-icon>
            </v-tab>

            <v-tab href="#tab-7" :disabled="tab !== 'tab-7'">
              Matrículas
              <v-icon>mdi-account-school</v-icon>
            </v-tab>

            <v-tab href="#tab-8" :disabled="tab !== 'tab-8'">
              Arquivo
              <v-icon>mdi-file</v-icon>
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item value="tab-1">
              <!-- <v-card flat class="pa-6">
                <v-progress-linear
                v-if="progress['tab-1'] >= 100"
                  :value="progress['tab-1']"
                  color="green"
                  height="20"
                  rounded
                >
                  <template v-slot:default="{ value }">
                    <strong>{{ Math.ceil(value) }}% dos campos obrigatórios preenchidos</strong>
                  </template>
                </v-progress-linear>
                <v-progress-linear
                v-else
                  :value="progress['tab-1']"
                  color="success"
                  height="20"
                  rounded
                >
                  <template v-slot:default="{ value }">
                    <strong>{{ Math.ceil(value) }}% dos campos obrigatórios preenchidos</strong>
                  </template>
                </v-progress-linear>
                <v-card-text>
                  <div class="mb-3">
                    <strong>{{ text }}</strong>
                  </div>
                  <v-btn color="secondary" class="" @click="gerarPlanilha('aba-00')"> Gerar Planilha para Preenchimento - Escola Atual</v-btn>
                </v-card-text>
                
              </v-card>
              <v-card flat class="pa-6">
                <v-card-text>
                  <div class="mb-3">
                    <strong>{{ text2 }}</strong>
                  </div>
                  <v-file-input
                  label="Adicionar planilha"
                  outlined
                  dense
                  prepend-icon="mdi-file-upload"
                  v-model="file"
                  @change="uploadPlanilha('aba-00')"
                  ></v-file-input>
                </v-card-text>
                <v-card-text style="background-color: #f5f5f5">
                  <strong class=" text-center">  Resultado da análise dos dados informados na planilha </strong>
                  <v-simple-table v-if="erros.length > 0" dense class="mt-3">
                    <template>
                      <thead>
                        <tr>
                      <th class="text-left">Erros detectados na planilha importada</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in erros" :key="item.id">
                      <td class="red--text">{{item }}</td>
                    </tr>
                  </tbody>
                </template>
                  </v-simple-table>
                  <p v-else>Nenhum erro detectado</p>
                
                </v-card-text>
              </v-card> -->
              <e-form-escola @event="nextTab($event)"></e-form-escola>
            </v-tab-item>

            <v-tab-item value="tab-2">
              <!-- <v-card flat class="pa-6">
                <v-progress-linear
                v-if="progress['tab-2'] >= 100"
                  :value="progress['tab-2']"
                  color="green"
                  height="20"
                  rounded
                >
                  <template v-slot:default="{ value }">
                    <strong>{{ Math.ceil(value) }}% dos campos obrigatórios preenchidos</strong>
                  </template>
                </v-progress-linear>
                <v-progress-linear
                v-else
                  :value="progress['tab-2']"
                  color="success"
                  height="20"
                  rounded
                >
                  <template v-slot:default="{ value }">
                    <strong>{{ Math.ceil(value) }}% dos campos obrigatórios preenchidos</strong>
                  </template>
                </v-progress-linear>
                <v-card-text>
                  <div class="mb-3">
                    <strong>{{ text }}</strong>
                  </div>
                  <v-btn color="secondary" class="" @click="gerarPlanilha('aba-10')"> Gerar Planilha para Preenchimento - Escola Atual</v-btn>
                </v-card-text>
                
              </v-card>
              <v-card flat class="pa-6">
                <v-card-text>
                  <div class="mb-3">
                    <strong>{{ text2 }}</strong>
                  </div>
                  <v-file-input
                  label="Adicionar planilha"
                  outlined
                  dense
                  prepend-icon="mdi-file-upload"
                  v-model="file"
                  @change="uploadPlanilha('aba-10')"
                  ></v-file-input>
                </v-card-text>
                <v-card-text style="background-color: #f5f5f5">
                  <strong class=" text-center">  Resultado da análise dos dados informados na planilha </strong>
                  <v-simple-table dense class="mt-3">
                    <template>
                      <thead>
                        <tr>
                      <th class="text-left">Erros detectados na planilha importada</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in erros" :key="item.id">
                      <td class="red--text">{{item }}</td>
                    </tr>
                  </tbody>
                </template>
                  </v-simple-table>
                
                </v-card-text>
              </v-card> -->
              <e-form-estrutura @event="nextTab($event)"></e-form-estrutura>
            </v-tab-item>

            <v-tab-item value="tab-3">
              <v-card flat class="pa-6">
                <v-card-text>Conteúdo da aba "Turmas".</v-card-text>
                <e-form-turma @event="nextTab($event)"></e-form-turma>
              </v-card>
            </v-tab-item>

            <v-tab-item value="tab-4">
              <v-card flat class="pa-6">
                <v-card-text>Conteúdo da aba "Pessoas Físicas".</v-card-text>
                <e-form-pessoa-fisica @event="nextTab($event)"></e-form-pessoa-fisica>
              </v-card>
            </v-tab-item>

            <v-tab-item value="tab-5">
              <v-card flat class="pa-6">
                <v-card-text>Conteúdo da aba "Gestão".</v-card-text>
                <e-form-gestao @event="nextTab($event)"></e-form-gestao>
              </v-card>
            </v-tab-item>

            <v-tab-item value="tab-6">
              <v-card flat class="pa-6">
                <v-card-text>Conteúdo da aba "Docentes".</v-card-text>
                <e-form-docente @event="nextTab($event)"></e-form-docente>
              </v-card>
            </v-tab-item>

            <v-tab-item value="tab-7">
              <v-card flat class="pa-6">
                <v-card-text>Conteúdo da aba "Alunos".</v-card-text>
                <e-form-matriculas @event="nextTab($event)"></e-form-matriculas>
              </v-card>
            </v-tab-item>

            <v-tab-item value="tab-8">
              <v-card flat class="pa-6">
                <v-card-text></v-card-text>
                <e-form-arquivo @event="nextTab($event)"></e-form-arquivo>
              </v-card>
            </v-tab-item>

            <v-tab-item value="tab-8">
              <v-card flat class="pa-6"> </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
export default {
  data() {
    return {
      file: null,
      tab: null,
      text: "1º Passo: Preencher a Planilha",
      text2: "2º Passo: Importar a Planilha preenchida",
      progress: {
        "tab-1": 0, // Porcentagem para a aba "Escolas"
        "tab-2": 50, // Porcentagem para a aba "Estrutura"
        "tab-3": 90, // Porcentagem para a aba "Turmas"
        "tab-4": 30, // Porcentagem para a aba "Pessoas Físicas"
        "tab-5": 80, // Porcentagem para a aba "Gestão"
        "tab-6": 60, // Porcentagem para a aba "Docentes"
        "tab-7": 40, // Porcentagem para a aba "Alunos"
      },
      erros: [],
    };
  },
  mounted() {
    // mudar pra tab-1 depois
    this.tab = "tab-1";
    // this.tab = "tab-8";
  },
  watch: {
    tab(value) {
      if (value === "tab-1") {
        this.text = "1º Passo: Preencher a Planilha";
        // this.getPercent("00");
      } else if (value === "tab-2") {
        this.text = "2º Passo: Importar a Planilha preenchida";
      } else if (value === "tab-3") {
        this.text = "3º Passo: Importar a Planilha preenchida";
      }
    },
  },
  methods: {
    nextTab($event) {
      this.tab = $event;
    },

    censoView(type) {
      this.$router.push({ name: "censo-escolar-view", params: { entidade: type } });
    },

    gerarArquivoCenso(type) {
      this.$loaderService.open("Carregando dados...");
      this.$services.censoService.gerarFile();
      this.$loaderService.close();
    },

    async gerarPlanilha(type) {
      this.$loaderService.open("Carregando dados...");
      await this.$services.censoService.export(type);
      this.$loaderService.close();
    },

    async getPercent(type) {
      this.$loaderService.open("Calculando porcentagem de preenchimento...");
      const data = await this.$services.censoService.getPercent(type);
      this.$loaderService.close();
      this.progress["tab-1"] = data;
    },

    async uploadPlanilha(type) {
      this.$loaderService.open("Carregando dados...");
      const data = await this.$services.censoService.import(this.file, type);
      this.$loaderService.close();
      this.erros = data.data;
    },
  },
};
</script>

<style scoped>
/* Estilização adicional */
.v-tabs-items {
  background-color: #fafafa;
}

.v-card {
  border-radius: 8px;
}

.v-btn {
  text-transform: none;
}
</style>
